export default __webpack_public_path__ + "alberta-hospital.e2f59d9fe4153a3723ed.svg";